/*
 * Animation for the menu in mobile and tablet mode
 * @param {HTMLelement} menuIcon
 */
raymont.menu = function(menuIcon){

    var nav = $(".nav-mini");

    //If menu is open
    if(menuIcon.hasClass('open')){
        menuIcon.removeClass('open');

        nav.animate({
            overflow: 'hidden',
            height : '0'
        }, 200);
    }
    else{
        menuIcon.addClass('open');

        nav.animate({
            height: '100%'
        }, 200);
    }
};
